import { render, staticRenderFns } from "./ChatTalks.vue?vue&type=template&id=4c7b2bd6&scoped=true&"
import script from "./ChatTalks.vue?vue&type=script&lang=js&"
export * from "./ChatTalks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b2bd6",
  null
  
)

export default component.exports